module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAA5SURBVDiNY/yfJ/6fAQaYGBUZJ7x4wEAGYCJH06hBowaNGjRwBrGg8RX+F0hQwaB///eT6aBBGEYAz+sJi/u/JfYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-3.png
// module id = DSSY
// module chunks = 1